export function historyUpdate (payload) {
    return async dispatch => {

        dispatch({
            type: 'HISTORY_UPDATE',
            payload: payload
        })

    }
}